import axios from "axios";

const getVideos = async categories => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/community-standup/get/${categories}`
    );
    return response.data;
  } catch {
    console.log("Get videos failed");
    return [];
  }
};

const getShowVideos = async showId => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/videos/${showId}`
    );
    return response.data;
  } catch {
    console.log("Get shows failed");
    return [];
  }
};

const getShowDetails = async (showId) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/shows/${showId}`
    );
    return response.data;
  } catch {
    console.log("Get show details failed");
    return {};
  }
};

export default getVideos;
export {
  getShowVideos,
  getShowDetails
};
